import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteUnlockUser } from "../../../data/usecases/user-management/remote-unlock-user";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UnlockUserInterface {
  unlockUser: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUnlockUserSlice: StateCreator<UnlockUserInterface> = (
  set,
  get
) => ({
  unlockUser: async (user_id: number) => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteUnblockUser = new RemoteUnlockUser(
      `${BASE_URL}${Endpoints.UNLOCK_USER}`,
      axiosHttpClient
    );
    let result = await remoteUnblockUser.unlock(user_id.toString());
  },
});
